/**
 * ScolairePresencePage — Présence des agents scolaire/cantine.
 *
 * Monte le composant unifié PlanningPresence (équipe / personne / année +
 * compteurs), branché sur l'API présence scolaire. Même schéma que le Service
 * technique / GRC / petite enfance — uniformisation.
 */
import { useState } from 'react';
import { useAuth } from '@/lib/auth-context';
import { api } from '@/lib/api';
import { ScolaireLayout } from '@/components/scolaire/ScolaireLayout';
import { PlanningPresence } from '@/components/planning/PlanningPresence';
import { DeclarerAbsenceModal } from '@/pages/service-technique/DeclarerAbsenceModal';
import { useToast } from '@/components/ui/Toast';

export function ScolairePresencePage() {
  const { user } = useAuth();
  const { toast } = useToast();
  const peutDeclarer = user?.role === 'manager' || user?.role === 'admin' || user?.role === 'super_admin';
  const [absModal, setAbsModal] = useState<{ agent: { id: string; fullName: string }; jourISO: string } | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <ScolaireLayout activeTab="presence-agents">
      <div className="mx-auto max-w-[1400px] px-4 py-5">
        <h1 className="mb-4 text-lg font-bold text-ink">{user?.role === 'agent' ? 'Ma présence' : 'Présence de l\'équipe'}</h1>
        <PlanningPresence
          key={reloadKey}
          accent="scolaire"
          role={user?.role ?? 'agent'}
          currentUserId={user?.id ?? ''}
          loadWeek={(weekStart) => api.scolaire.planning.presenceSemaine(weekStart)}
          loadAnnee={(annee, agentId) => api.scolaire.planning.presenceAnnee(annee, agentId)}
          loadCompteurs={(annee, agentId) => agentId ? api.rh.compteursAgent(agentId, annee) : api.rh.mesCompteurs(annee)}
          onDeclareAbsence={peutDeclarer ? (agent, jourISO) => setAbsModal({ agent, jourISO }) : undefined}
        />
      </div>

      {absModal && (
        <DeclarerAbsenceModal
          agent={absModal.agent}
          jourISO={absModal.jourISO}
          service="scolaire_cantine"
          onClose={() => setAbsModal(null)}
          onDone={(conflits) => {
            setAbsModal(null);
            setReloadKey((k) => k + 1);
            toast.success(conflits > 0
              ? `Absence enregistrée. ${conflits} tâche(s) à réaffecter — responsable alerté.`
              : 'Absence enregistrée.');
          }}
        />
      )}
    </ScolaireLayout>
  );
}
